import { z } from 'zod';
import { PinComponentSchema } from '../pin-component';
import { LayoutPartSchema } from '../pin-component/layout-part';
import { BaseInteractiveQuestionPinSettingsSchema, BasePinSchema, BaseTemplateLayoutSchema } from './base-pin';

export const DragAndDropPinLayoutKeySettingsSchema = z.enum([
  'TITLE_ONLY',
  'SINGLE_DROP_ZONE',
  'QUAD_DROP_ZONE_TEXT',
  'QUAD_DROP_ZONE_IMAGE',
]);
export type DragAndDropPinLayoutKey = z.infer<typeof DragAndDropPinLayoutKeySettingsSchema>;

export const DragAndDropLinkedComponentSchema = z.record(z.string(), z.array(z.string()));

export type DragAndDropLinkedComponent = z.infer<typeof DragAndDropLinkedComponentSchema>;

export const DragAndDropPinLayoutPartKeySchema = LayoutPartSchema.extract([
  'TITLE',
  'IMAGE1',
  'IMAGE2',
  'IMAGE3',
  'IMAGE4',
  'DROP_ZONE_1',
  'DROP_ZONE_2',
  'DROP_ZONE_3',
  'DROP_ZONE_4',
  'TEXT_ITEM_1',
  'TEXT_ITEM_2',
  'TEXT_ITEM_3',
  'TEXT_ITEM_4',
]);

export const DragAndDropPinLayoutTemplateSchema = BaseTemplateLayoutSchema.extend(
  z.object({
    key: DragAndDropPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(DragAndDropPinLayoutPartKeySchema, PinComponentSchema.optional()),
    settings: z
      .object({
        linkedPinComponents: DragAndDropLinkedComponentSchema,
      })
      .optional(),
  }).shape
);
export type DragAndDropPinLayoutTemplate = z.infer<typeof DragAndDropPinLayoutTemplateSchema>;

export const DragAndDropPinSettingsSchema = BaseInteractiveQuestionPinSettingsSchema.extend(
  z.object({
    questionId: z.string().optional(),
    layout: DragAndDropPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(DragAndDropPinLayoutPartKeySchema, z.string().optional()),
    linkedPinComponents: DragAndDropLinkedComponentSchema,
  }).shape
);
export type DragAndDropPinSettings = z.infer<typeof DragAndDropPinSettingsSchema>;

export const DragAndDropPinTypeSchema = z.literal('DRAG_AND_DROP');

export const DragAndDropPinSchema = BasePinSchema.extend(
  z.object({
    type: DragAndDropPinTypeSchema,
    settings: DragAndDropPinSettingsSchema,
  }).shape
);
export type DragAndDropPin = z.infer<typeof DragAndDropPinSchema>;
